import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import Input from "components/form/Input";
import {  Flex, Stack, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { getPriceTagsCombosFilteredData, getPriceTagsFilteredData } from "../../services/priceTagsServices";

export default  function FilterModal ({ onClose, data})  {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [filteredData, setFilteredData] = useState(data);

  // console.log(filteredData)
  const [filterCriteria, setFilterCriteria] = useState({
    Name:""
  });


  const handleFilterPriceTags = (e) => {
    e.preventDefault();

    const filteredResult = data.filter((item) => {
      const { Name } = filterCriteria;

      let filterName = true;

      if (Name) {
        filterName = item?.PriceTagsName.toLowerCase().includes(Name.toLowerCase());
      }

      return (
        filterName 
         
      );

    });

    setFilteredData(filteredResult);
    dispatch(getPriceTagsFilteredData(filteredResult));
    onClose();
  };

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.payment_methods.filter_payment_methods")}
      modalContent={(
        <Box p={4}>
          <form 
          onSubmit={handleFilterPriceTags}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.payment_methods.name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.payment_methods.name")}
                name="Name"
                value={filterCriteria.Name}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Name: e.target.value,
                  })
                }
              />
             

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      )}
    />
  )
};